/**
 * App 主线包列表页面
 */

import React from 'react'
import Dialog from '@tencent/spaui-dialog'
import useBindApp from './hooks/useBindApp'
import DialogPkgNameInput from 'pureComponents/DialogPkgNameInput'
import AlertTips from 'pureComponents/AlertTips'

const AddAppDialog = props => {
    const { handleSubmit, disableSubmit, appid, setAppId, error } = useBindApp(props)
    const onCancelClick = () => {
        props.onClose && props.onClose()
    }

    const handleChange = val => {
        setAppId(val)
    }

    return (
        <Dialog
            className="track-dialog"
            onSubmit={handleSubmit}
            title="绑定APP"
            style={{
                width: '500px',
            }}
            type="normal"
            submitLabel={disableSubmit ? '提交中...' : '确定'}
            disabled={disableSubmit}
            backdrop
            {...props}
            onClose={onCancelClick}
            onCancel={onCancelClick}
        >
            {error ? (
                <div className="track-body-item">
                    <AlertTips type="error" icon="warn">
                        {error}
                    </AlertTips>
                </div>
            ) : null}
            <DialogPkgNameInput
                value={appid}
                onChange={val => handleChange(val)}
                label="APPID"
                placeholder="请输入APPID"
            />
        </Dialog>
    )
}

export default AddAppDialog
